import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js'; // ✅ Import CryptoJS

@Injectable({
  providedIn: 'root'
})
export class EncryptUrlService {

  constructor() { }

  // ✅ ฟังก์ชันเข้ารหัส URL (Base64)
  encryptURL(url: string): string {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(url));
  }

  // ✅ ฟังก์ชันถอดรหัส URL (Base64)
  decryptURL(encrypted: string): string {
    return CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(encrypted));
    // return CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(encrypted));
  }

  // CryptoJS.enc.Base64.parse(encrypted) ผิด
  // CryptoJS.AES.decrypt(encrypted, secretKey) ถูก

}
